const isNavItemVisible = (item, context) => {
  const { featureFlags = {}, userRoles = [] } = context
  if (item.featureFlag && !featureFlags[item.featureFlag]) return false

  if (Array.isArray(item.requiredRoles) && item.requiredRoles.length) {
    const hasRequiredRole = item.requiredRoles.some(role => userRoles.includes(role))
    if (!hasRequiredRole) return false
  }

  return true
}

export const filterNavMenuItems = (items = [], context = {}) => {

  return items
    .map(item => {
      if (item.header && Array.isArray(item.items)) {
        const filteredItems = filterNavMenuItems(item.items, context)
        if (!filteredItems.length) return null
        return { ...item, items: filteredItems }
      }

      if (item.submenu) {
        if (!isNavItemVisible(item, context)) return null
        const filteredSubmenu = filterNavMenuItems(item.submenu, context)
        if (!filteredSubmenu.length) return null
        return { ...item, submenu: filteredSubmenu }
      }

      return isNavItemVisible(item, context) ? item : null
    })
    .filter(Boolean)
}
